import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRootStore } from '@qsrsoft/myq-core';
export { default as mcdRoutes } from './mcd/routes';
export { default as thRoutes } from './th/routes';
export { default as standardRoutes } from './standard/routes';
import mcdRoutes from './mcd/routes';
import thRoutes from './th/routes';
import standardRoutes from './standard/routes';
import marketingRoutes from './marketingAgnency/routes';
import commsHubRoutes from './commsHub/routes';
import scheduledReportsRoutes from './scheduledReports/routes';
import multiClientRoutes from './multiClient/routes';
import { MT_ENTERPRISES } from './multiClient/mtEnterprises';
import adminRoutes from './admin/routes';

// const standardSetCountryCodes = ['za'];

export function getRoutes(enterprise, countryCode) {
  // DEV OVERRIDE: uncomment to force a specific route set
  // return [...adminRoutes];

  if (!enterprise || !countryCode) {
    // try and find it in local storage
    const userString = localStorage.getItem('user');
    if (userString) {
      const userObj = JSON.parse(userString);
      enterprise = enterprise || userObj?.user?.organization?.enterpriseClient;
      countryCode = countryCode || userObj?.user?.organization?.countryCode;
    }
  }

  // MT enterprise whitelist lives in `multiClient/mtEnterprises.js` so the
  // sidebar `menuFilters` and this route resolver stay in sync. Plain
  // `TimHortons` (legacy pipeline) is deliberately absent — it falls through
  // to `thRoutes` below.
  const ec = enterprise?.toLowerCase();
  const isMtEnterprise = MT_ENTERPRISES.some((e) => e.toLowerCase() === ec);
  if (
    (countryCode && countryCode?.toLowerCase() === 'za') ||
    (isMtEnterprise && ['us', 'ca'].includes(countryCode?.toLowerCase()))
  ) {
    return [...multiClientRoutes, ...scheduledReportsRoutes, adminRoutes];
  }

  if (enterprise === 'CommsHub') {
    return [...commsHubRoutes, ...scheduledReportsRoutes];
  }
  if (enterprise === 'McDonalds') {
    return [...mcdRoutes, ...scheduledReportsRoutes];
  }
  if (ec?.includes('timhortons')) {
    return [...thRoutes, ...scheduledReportsRoutes];
  }
  if (enterprise === 'Popeyes') {
    return [...standardRoutes, ...scheduledReportsRoutes];
  }
  if (enterprise === 'MarketingAgency') {
    return [...marketingRoutes, ...scheduledReportsRoutes];
  }
  if (enterprise === 'DataPassRecipient') {
    return [
      {
        // this just boots them straight to /datapass/
        path: '/',
        alias: '/home-dashboard',
        name: 'DataPass',
        beforeEnter() {
          window.location.href = '/datapass/recipient/RequestOO';
        },
      },
    ];
  }
  return [];
}

export default function useRoutes() {
  const store = useRootStore();
  const { enterpriseClient, countryCode } = storeToRefs(store);
  return computed(() => {
    return getRoutes(enterpriseClient.value, countryCode.value);
  });
}
